// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"PaginationBar_paginationWrapper__TgPBm","pagination":"PaginationBar_pagination__1s-K5","selected":"PaginationBar_selected__3jgEt"};